import globalIP from '../GlobelIP';

const ip = globalIP;

const fetchColors = async (
  setColordata,
  isLoadingcolor,
  setIsLoadingcolor,
  filterStatus = 'Discontinue'
) => {
  if (isLoadingcolor) {
    return;
  }
  setIsLoadingcolor(true);
  try {
    const response = await fetch(`${ip}/api/mstcolors?filters[dis][$ne]=${filterStatus}`);
    const json = await response.json();

    const allData = [];

    const pageResponse = await fetch(
      `${ip}/api/mstcolors?pagination[pageSize]=${json.meta.pagination.total}&filters[dis][$ne]=${filterStatus}&sort[0]=ColorName`
    );
    const pageJson = await pageResponse.json();

    const processedData = pageJson.data.map(item => ({
      label: item.attributes.ColorName,
      value: item.attributes.ColorCode
    }));

    allData.push(...processedData);
    // console.log('allData', allData);
    setColordata(allData);
    //   return allData;
  } catch (error) {
    console.error('Error fetching color data:', error);
    return [];
  } finally {
    setIsLoadingcolor(false);
  }
};

const fetchFinishes = async (
  setFinishData,
  isLoadingfin,
  setIsLoadingfin,
  filterStatus = 'Discontinue'
) => {
  if (isLoadingfin) {
    return;
  }
  setIsLoadingfin(true);
  try {
    const response = await fetch(
      `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=${filterStatus}&sort[0]=FinishName`
    );
    const json = await response.json();

    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=${filterStatus}&sort[0]=FinishName`
      );
      const pageJson = await pageResponse.json();

      const processedData = pageJson.data.map(item => ({
        label: item.attributes.FinishName,
        value: item.attributes.FinishCode
      }));

      allData.push(...processedData.filter(item => item.label !== ''));
    }

    setFinishData(allData);
  } catch (error) {
    console.error('Error fetching finish data:', error);
  } finally {
    setIsLoadingfin(false);
  }
};

const fetchHsn = async (
  setHsndata,
  isLoadinghsn,
  setIsLoadinghsn,
  filterStatus = 'Discontinue'
) => {
  if (isLoadinghsn) {
    return;
  }

  setIsLoadinghsn(true);

  try {
    const response = await fetch(
      `${ip}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=${filterStatus}&sort[0]=hscode`
    );
    const json = await response.json();

    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=${filterStatus}&sort[0]=hscode`
      );
      const pageJson = await pageResponse.json();

      const processedData = pageJson.data.map(item => ({
        label: item.attributes.Description
          ? item.attributes.hscode + '-' + item.attributes.Description
          : item.attributes.hscode,
        value: item.attributes.hscode
      }));

      allData.push(...processedData);
    }

    setHsndata(allData.sort((a, b) => a.label.localeCompare(b.label)));
  } catch (error) {
    console.error('Error fetching HSN data:', error);
  } finally {
    setIsLoadinghsn(false);
  }
};

const fetchMaterials = async (
  setMaterialdata,
  isLoadingmat,
  setIsLoadingmat,
  params,
  filterStatus = 'Discontinue'
) => {
  if (isLoadingmat) {
    return;
  }
  setIsLoadingmat(true);
  try {
    const response = await fetch(
      `${ip}/api/mstmaterials?&pagination[page]=1&filters[dis][$ne]=${filterStatus}${params}&sort[0]=MaterialName`
    );
    const json = await response.json();

    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstmaterials?&pagination[page]=${page}&filters[dis][$ne]=${filterStatus}${params}&sort[0]=MaterialName`
      );
      const pageJson = await pageResponse.json();

      const processedData = pageJson.data.map(item => ({
        label: item.attributes.MaterialName,
        value: item.attributes.MaterialCode
      }));

      allData.push(...processedData);
    }

    setMaterialdata(allData.sort((a, b) => a.label.localeCompare(b.label)));
  } catch (error) {
    console.error('Error fetching material data:', error);
  } finally {
    setIsLoadingmat(false);
  }
};

const fetchMaterialCollection = async (setCollectiondata, isLoadingcoll, setIsLoadingcoll) => {
  if (isLoadingcoll) {
    return;
  }
  setIsLoadingcoll(true);
  try {
    const response = await fetch(
      `${ip}/api/mstmaterialcollections?&pagination[page]=1&filters[dis][$ne]=Discontinue&sort[0]=MatCollectionName`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstmaterialcollections?&pagination[page]=${page}&filters[dis][$ne]=Discontinue&sort[0]=MatCollectionName`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.MatCollectionName,
        value: item.attributes.MatCollectionCode
      }));
      allData.push(...processedData);
    }
    setCollectiondata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingcoll(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchCategory = async (
  setCategorydata,
  isLoadingc,
  setIsLoadingc,
  SetIsLoadingTableData = null,
  setProgress = null,
  filterStatus = 'Discontinue'
) => {
  if (setProgress !== null) setProgress(30);

  if (isLoadingc) {
    return;
  }

  setIsLoadingc(true);

  try {
    const response = await fetch(
      `${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=${filterStatus}&sort[0]=CategoryName`
    );
    // console.log('response22', response);
    if (setProgress !== null) setProgress(60);

    const json = await response.json();
    const allData = [];

    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=${filterStatus}&sort[0]=CategoryName`
      );
      const pageJson = await pageResponse.json();

      const processedData = pageJson.data.map(item => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode,
        sname: item.attributes.ShortName
      }));

      allData.push(...processedData);
    }
    // console.log('category', allData);
    // setCategorydata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setCategorydata(
      allData.sort((a, b) =>
        (a.label ?? '').toString().localeCompare((b.label ?? '').toString(), undefined, {
          sensitivity: 'base'
        })
      )
    );

    if (SetIsLoadingTableData !== null) SetIsLoadingTableData(false);
    setIsLoadingc(false);
    if (setProgress !== null) setProgress(100);
  } catch (error) {
    console.error('Error fetching category data:', error);
  } finally {
    setIsLoadingc(false);
    if (setProgress !== null) setProgress(100);
  }
};

const fetchSkuUnique = async (setSkudata, isLoadingsku, setIsLoadingsku) => {
  if (isLoadingsku) {
    return;
  }

  setIsLoadingsku(true);

  try {
    const response = await fetch(`${ip}/api/buyers-sku`);
    const json = await response.json();

    const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
    json.forEach(item => {
      if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
        uniqueKeywords.add(item.BuyerSku);
      }
    });

    const processedData = Array.from(uniqueKeywords).map(keyword => ({
      label: keyword,
      value: keyword
    }));

    setSkudata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
  } catch (error) {
    console.error('Error fetching SKU data:', error);
  } finally {
    setIsLoadingsku(false);
  }
};

const fetchAlias = async (setAliasdata, isLoadingalias, setIsLoadingalias, isVariant = false) => {
  if (isLoadingalias) return;

  setIsLoadingalias(true);

  try {
    // Correct URL based on type
    const url = isVariant
      ? `${ip}/api/variant-products?populate=*&pagination[limit]=-1`
      : `${ip}/api/fetchs-aliascd`;

    const response = await fetch(url);
    const json = await response.json();

    // -----------------------------
    // 1️⃣ Normalize data structure
    // -----------------------------
    let dataArray = [];

    if (isVariant) {
      // Strapi variant API → json.data
      dataArray = json?.data ?? [];
    } else {
      // Normal alias API → json is an array
      dataArray = Array.isArray(json) ? json : [];
    }

    // -----------------------------
    // 2️⃣ Extract ProductId safely
    // -----------------------------
    const processed = dataArray
      .map(item => {
        const productId = isVariant ? item?.attributes?.ProductId : item?.ProductId;

        if (!productId || productId.trim() === '') return null;

        return {
          label: productId,
          value: productId
        };
      })
      .filter(Boolean) // remove null
      .sort((a, b) => a.label.localeCompare(b.label));

    // -----------------------------
    // 3️⃣ Update State
    // -----------------------------
    setAliasdata(processed);
  } catch (error) {
    console.error('Error fetching alias data:', error);
  } finally {
    setIsLoadingalias(false);
  }
};

const fetchBuyers = async (setBuyerNamedata, isLoadingbu, setIsLoadingbu, params = '') => {
  if (isLoadingbu) {
    return;
  }
  setIsLoadingbu(true);
  try {
    const response = await fetch(`${ip}/api/buyer-details?&pagination[page]=1${params}`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/buyer-details?&pagination[page]=${page}${params}`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyernm,
        company: item.attributes.companynm
      }));
      allData.push(...processedData);
    }
    setBuyerNamedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingbu(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchMadeBy = async (setMadedata, isLoadingmade, setIsLoadingmade) => {
  if (isLoadingmade) {
    return;
  }
  setIsLoadingmade(true);
  try {
    const response = await fetch(`${ip}/api/mades-by`);
    const json = await response.json();
    const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
    json.forEach(item => {
      if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
        uniqueKeywords.add(item.MadeBy);
      }
    });
    const processedData = Array.from(uniqueKeywords).map(keyword => ({
      label: keyword,
      value: keyword
    }));
    setMadedata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingmade(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchHeads = async setHead => {
  try {
    const response = await fetch(`${ip}/api/mstfilters?populate=*`);
    const json = await response.json();
    const filteredData = json.data.map(item => ({
      FilterName: item.attributes.FilterName,
      filterstatus: item.attributes.filterstatus
    }));
    setHead(filteredData);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

const fetchProductLabel = async setLabel => {
  try {
    const response = await fetch(`${ip}/api/product-labels`);
    const json = await response.json();
    setLabel(json.data);
  } catch (error) {
    console.error('Error fetching currency data:', error);
  }
};

const fetchProductDesign = async (setProdDdata, isLoadingprod, setIsLoadingprod) => {
  if (isLoadingprod) {
    return;
  }
  setIsLoadingprod(true);
  try {
    const response = await fetch(`${ip}/api/products-designer`);
    const json = await response.json();
    const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
    json.forEach(item => {
      if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
        uniqueKeywords.add(item.ProductDesigner);
      }
    });
    const processedData = Array.from(uniqueKeywords).map(keyword => ({
      label: keyword,
      value: keyword
    }));
    setProdDdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingprod(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchProductName = async (setProdNamedata, isLoadingpron, setIsLoadingpron) => {
  if (isLoadingpron) {
    return;
  }
  setIsLoadingpron(true);
  try {
    const response = await fetch(`${ip}/api/products-name`);
    const json = await response.json();
    const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

    json.forEach(item => {
      if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
        uniqueKeywords.add(item.ProductName);
      }
    });

    const processedData = Array.from(uniqueKeywords)
      .map(keyword => ({
        label: keyword,
        value: keyword
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    setProdNamedata(processedData);
    setIsLoadingpron(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchSearchKeyword = async (setSearchdata, isLoadingse, setIsLoadingse) => {
  if (isLoadingse) {
    return;
  }
  setIsLoadingse(true);
  try {
    const response = await fetch(`${ip}/api/searchs-keyword`);
    const json = await response.json();
    const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

    json.forEach(item => {
      if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
        uniqueKeywords.add(item.SearchKeyword);
      }
    });

    const processedData = Array.from(uniqueKeywords)
      .map(keyword => ({
        label: keyword,
        value: keyword
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    setSearchdata(processedData);
    setIsLoadingse(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchProductTypes = async (
  setProductypedata,
  isLoadingpro,
  setIsLoadingpro,
  selectedCategoryCode = [],
  selectedCategory = []
) => {
  if (isLoadingpro) {
    return;
  }
  setIsLoadingpro(true);

  let categoryFilter = '';
  if (selectedCategory.length > 0) {
    const categoryFilterString = selectedCategory
      .map(cat => `filters[Categorycode][$eq]=${cat}`)
      .join('&');
    categoryFilter = `&${categoryFilterString}`;
  }

  try {
    // ✅ Ensure selectedCategoryCode is always an array
    const normalizedCategoryCode = Array.isArray(selectedCategoryCode)
      ? selectedCategoryCode
      : [selectedCategoryCode];

    // ✅ Now, it's always an array, so .map() will not cause errors
    const productIdsQueryParam = normalizedCategoryCode
      .map(id => `filters[Categorycode][$in][]=${id}`)
      .join('&');

    const apiUrl = `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1${categoryFilter}`;

    const response = await fetch(apiUrl);
    const json = await response.json();

    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}${categoryFilter}`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode
      }));
      allData.push(...processedData);
    }
    setProductypedata(allData);
    setIsLoadingpro(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchComponent = async (setCompdata, isLoadingcomp, setIsLoadingcomp) => {
  if (isLoadingcomp) {
    return;
  }
  setIsLoadingcomp(true);
  try {
    const response = await fetch(
      `${ip}/api/mst-components?&pagination[page]=1&filters[dis][$ne]=Discontinue`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mst-components?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.CompName,
        value: item.attributes.CompName
      }));
      allData.push(...processedData);
    }
    setCompdata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingcomp(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchShape = async (setShapedata, isLoadingshape, setIsLoadingshape) => {
  if (isLoadingshape) {
    return;
  }
  setIsLoadingshape(true);
  try {
    const response = await fetch(`${ip}/api/shape-masters?&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/shape-masters?&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.ShapeName,
        value: item.attributes.ShapeCode
      }));
      allData.push(...processedData);
    }
    setShapedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingshape(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchSeason = async (setSeasondata, isLoadingseason, setIsLoadingseason) => {
  if (isLoadingseason) {
    return;
  }
  setIsLoadingseason(true);
  try {
    const response = await fetch(`${ip}/api/season-masters?&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/season-masters?&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.SeasonName,
        value: item.attributes.SeasonName
      }));
      allData.push(...processedData);
    }
    setSeasondata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingseason(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchPtechnique = async (setPtechdata, isLoadingptech, setIsLoadingptech) => {
  if (isLoadingptech) {
    return;
  }
  setIsLoadingptech(true);
  try {
    const response = await fetch(`${ip}/api/mst-ptechniques?&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/mst-ptechniques?&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.PTechName,
        value: item.attributes.PTechcode
      }));
      allData.push(...processedData);
    }
    setPtechdata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingptech(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

const fetchCurrency = async (setCurrencydata, isLoadingCurr, setIsLoadingCurr) => {
  if (isLoadingCurr) {
    return;
  }
  setIsLoadingCurr(true);
  try {
    const response = await fetch(`${ip}/api/currency-masters?&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ip}/api/currency-masters?&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.currencyname,
        value: item.attributes.currencyname,
        exchangerate: item.attributes.exchangerate
      }));
      allData.push(...processedData);
    }
    setCurrencydata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    setIsLoadingCurr(false);
  } catch (error) {
    console.error('Error fetching category data:', error);
  }
};

// Export multiple API functions
export {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchMaterialCollection,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes,
  fetchComponent,
  fetchShape,
  fetchSeason,
  fetchPtechnique,
  fetchCurrency
};
